define('modules/form_editor/models/form',['require','exports','module','backbone','modules/editor/models/editorstate','modules/editor/models/activeitemstate','../collections/fields'],function (require, exports, module) {
  "use strict";
  var Backbone = require("backbone"),
      EditorState = require("modules/editor/models/editorstate"),
      ActiveItemState = require("modules/editor/models/activeitemstate"),
      FieldCollection = require("../collections/fields");

  var Serialization = {
    parse: function(json){
      module.exports.__super__.parse.apply(this,json);
      this.fields = FieldCollection.fromJSON(json.fields || []);
    },
    toJSON: function(){
      var json =  module.exports.__super__.toJSON.call(this,[]);
      _.extend(json, { fields: this.fields.toJSON() });
      return json;
    }
  };

  var Controller = {
    selectItem: function(item){
      if (item) {
        this.activeItemState.set("item", item);
      } else {
        this.activeItemState.unset("item");
      }
    },
    addField: function(fieldName, attrs, opts){
      var element = this.fields.addField(fieldName, attrs, opts || {});
      this.selectItem(element);
    },
    moveUpField: function(){
      if(this.activeItemState.has("item") && this.fields.length > 1){
        var currentField = this.activeItemState.get("item");
        this.fields.moveUp(currentField);
        this.selectItem(currentField);
      }
    },
    moveDownField: function(){
      if(this.activeItemState.has("item") && this.fields.length > 1){
        var currentField = this.activeItemState.get("item");
        this.fields.moveDown(currentField);
        this.selectItem(currentField);
      }
    },
    duplicateField: function(){
      if(this.activeItemState.has("item")){
        var currentField = this.activeItemState.get("item");
        var newField = this.fields.duplicate(currentField);
        this.selectItem(newField);
      }
    },
    removeField: function(){
      if(this.activeItemState.has("item")){
        var currentField = this.activeItemState.get("item"),
            index = this.fields.indexOf(currentField);

        this.fields.remove(currentField);
        this.checkSocialBindings(currentField);
        this.activeItemState.unset("item");
        this._selectNext(index);
      }
    },

    onActiveItemChange: function(model){
      this.trigger("active:item:change", model.get("item"));
    },

    _selectNext: function(index){
      if(index > this.fields.length-1){
        index = this.fields.length-1;
      }
      var field = this.fields.at(index);
      if(field){
        this.activeItemState.set("item", field);
      }
      else {
        this.activeItemState.unset("item");
      }
    },

    checkSocialBindings: function(model){
      if (model.get("name") === "custom:fblogin") {
        this.fields.invoke("cleanSocialBinding");
      }
    },
    toggleAdvancedMode: function(model, isShown){
      EditorState.set("isAdvancedMode", isShown);
    },
  };

  var FormModel = Backbone.Model.extend({
    initialize: function(attrs, options){
      this.activeItemState = new ActiveItemState();
      this.listenTo(this.activeItemState, "change", this.onActiveItemChange);
      //call this.parse to force parsing on new() instead of only in fetch
      this.parse(attrs);
      this.set("isAdvancedMode", EditorState.get("isAdvancedMode"));
      this.on("change:isAdvancedMode", this.toggleAdvancedMode);
    },
    hasSocialLogin: function(){
      return this.fields.hasSocialLogin();
    },
    hasFacebookLogin: function(){
      return this.fields.getSocialElements("facebook").length;
    },
    hasLinkedInLogin: function(){
      return this.fields.getSocialElements("linkedin").length;
    },
    hasGoogleReCaptcha: function () {
      return this.fields.hasGoogleReCaptcha();
    },
    getSocialLoginOrder: function(){
      return this.fields.getSocialLoginOrder();
    }
  });

  _.extend(FormModel.prototype, Serialization, Controller);

  module.exports = FormModel;
});

